import { render, staticRenderFns } from "./RegisXComplete.vue?vue&type=template&id=08c452be&scoped=true"
import script from "./RegisXComplete.vue?vue&type=script&lang=js"
export * from "./RegisXComplete.vue?vue&type=script&lang=js"
import style0 from "./RegisXComplete.vue?vue&type=style&index=0&id=08c452be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c452be",
  null
  
)

export default component.exports